import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface Listing {
  id: string;
  address: string;
  beds: number;
  baths: number;
  price: number;
}

interface ListingsState {
  offers: Listing[];
  sells: Listing[];
  rents: Listing[];
}

const initialState: ListingsState = {
  offers: [],
  sells: [],
  rents: []
};

export const specialListingsSlice = createSlice({
  name: "listings",
  initialState,
  reducers: {
    addOfferListings: (state, action: PayloadAction<Listing[]>) => {
      state.offers = [...state.offers, ...action.payload];
    },
    addSellListings: (state, action: PayloadAction<Listing[]>) => {
      state.sells = [...state.sells, ...action.payload];
    },
    addRentListings: (state, action: PayloadAction<Listing[]>) => {
      state.rents = [...state.rents, ...action.payload];
    },
    clearListings: (state) => {
      state.offers = [];
      state.sells = [];
      state.rents = [];
    }
  }
});

export const {
  addOfferListings,
  addSellListings,
  addRentListings,
  clearListings
} = specialListingsSlice.actions;


